import React from 'react';
import { MiciCaseContext, MiciContextType } from '../../../services/types/MiciCases';

const Context = React.createContext<MiciContextType>({
  data: {} as MiciCaseContext,
  reload: () => {},
  loading: false,
});

export default Context;
